
import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import Navbar from '@/components/shared/navbar.vue' // @ is an alias to /src
import {
  isAuthenticated,
  markAsRead
  // getNotifications
} from './components/admin/users/users.service'
import { CurrentUser, Notification, Role } from './models'
import {
  getDoctorInsurances,
  getUserInsurances
} from './components/doctors/doctors.service'

const AppModule = namespace('app')

@Component({
  components: {
    Navbar
  }
})
export default class App extends Vue {
  @AppModule.Getter
  public _isLoading!: () => boolean

  @AppModule.Getter
  public _isUploading!: () => boolean

  @AppModule.Getter
  public _getUserInsurances!: () => string

  @AppModule.Getter
  public _messages!: () => Notification[]

  @AppModule.Getter
  public _messageCount!: () => number

  @AppModule.Action('fetchNotifications') fetchNotifications!: (
    userId: string
  ) => Promise<void>
  public message = {
    title: null,
    body: null,
    notificationId: null
  }

  @AppModule.State
  public toastMessage!: () => Notification
  public currentYear: number = new Date().getFullYear()
  public fields = [
    {
      key: 'id',
      label: 'Record Number'
    },
    {
      key: 'insurance',
      label: 'Insurance'
    },
    {
      key: 'contract',
      label: 'Contract'
    },
    {
      key: 'name',
      label: 'Name'
    },
    {
      key: 'dob',
      label: 'DOB (MM/DD/YYYY)'
    },
    {
      key: 'age',
      label: 'Age'
    },
    {
      key: 'sex',
      label: 'Sex'
    },
    {
      key: 'notes',
      label: 'Notes'
    },
    {
      key: 'notesMagToMD',
      label: 'Notes MAG to MD'
    },
    {
      key: 'statusFirstSemester',
      label: 'Status Billing-First-Semester'
    },
    {
      key: 'statusSecondSemester',
      label: 'Status Billing-Second-Semester'
    },
    {
      key: 'active',
      label: 'Active'
    },
    {
      key: 'raf',
      label: 'RAF Total'
    },
    {
      key: 'audit',
      label: 'Audit Code MAG'
    }
  ]
  public items = [
    {
      id: 10010,
      insurance: 'ARS HUMANO',
      contract: 1234,
      name: 'Johnny Encarnacion',
      dob: '10/06/1992',
      age: 28,
      sex: 'M',
      notes: 'this is a test note.',
      notesMagToMD: 'this is another test note from MAG to MD',
      status: '',
      active: true,
      statusFirstSemester: 'active',
      statusSecondSemester: 'inactive',
      raf: 4.43,
      audit: 1001
    }
  ]

  public insurances = [
    {
      value: 1,
      text: 'ARS HUMANO'
    },
    {
      value: 2,
      text: 'UNIVERSAL'
    }
  ]
  public contracts = [
    {
      text: '12345',
      value: 12345
    },
    {
      text: '125',
      value: 125
    }
  ]
  public genders = [
    {
      value: 1,
      text: 'M'
    },
    {
      value: 2,
      text: 'F'
    }
  ]
  public form = {
    insurance: null,
    contract: null,
    dob: new Date(),
    gender: null,
    notes: null,
    notesMAG: null,
    rafTotal: 4.24,
    auditCode: null,
    firstSemester: true,
    secondSemester: false,
    active: true
  }
  get isIdle() {
    const idle = this.$store.state.idleVue.isIdle
    // const progress = this._progress()

    if (
      idle &&
      isAuthenticated() &&
      !this._isUploading &&
      this.$route.name != 'SmartPN'
    ) {
      this.$swal.fire(
        'Session Expired',
        'You were redirected to the login page due to inactivity.'
      )

      this.clearAllButOne('trusted_device')
      this.$router.push('Login')
    }
    return idle
  }
  public clearAllButOne(keyToKeep) {
    // 1. Save the value of the key you want to preserve
    const keptValue = localStorage.getItem(keyToKeep)

    // 2. Clear all items from localStorage for the current domain
    localStorage.clear()

    // 3. Restore the preserved key-value pair if it existed
    if (keptValue !== null) {
      localStorage.setItem(keyToKeep, keptValue)
    }
  }

  @Watch('toastMessage')
  triggerToast(messages: Notification) {
    // console.log(messages)
    switch (messages.messageTitle) {
      case 'Upload Completed':
        this.$store.dispatch('app/massiveLoadNotifications', true)
        this.$store.dispatch('app/setUploadCompletedFlag', true)
        this.$bvToast.toast(messages.messageBody, {
          title: `${messages.messageTitle}`,
          toaster: 'b-toaster-bottom-right',
          solid: true,
          appendToast: true,
          variant: 'success'
        })
        break
      default:
        this.$bvToast.toast(messages.messageBody, {
          title: `${messages.messageTitle}`,
          toaster: 'b-toaster-bottom-right',
          solid: true,
          appendToast: true,
          variant: 'info'
        })
    }
  }

  public async markAsRead(notificationId: number) {
    // console.log(notificationId)
    await markAsRead(notificationId)
    this.$root.$emit('bv::hide::modal', 'message-modal', '#btnShow')
    // await this.fetchNotifications(this.currentUser.rmtUserId)
  }

  async created() {
    if (isAuthenticated() && localStorage.getItem('token')) {
      const currentUser: CurrentUser = JSON.parse(
        localStorage.getItem('currentUser')
      )
      const userId = currentUser.userId.toString()
      this.$store.dispatch('app/initSignalR', userId)
      this.$store.dispatch(
        'app/fetchNotifications',
        currentUser.rmtUserId.toString()
      )
      console.log(this._getUserInsurances)
      const user = currentUser
      if (this._getUserInsurances !== null) {
        return
      }

      switch (user.role) {
        case Role.Insurance:
          await this.getUserInsurances(user.rmtUserId)
          break
        case Role.InsuranceStaff:
          await this.getUserInsurances(user.rmtUserId)
          break
        case Role.Doctor:
          await this._getDoctorInsurances(user.rmtUserId)
          break
        case Role.DoctorStaff:
          await this._getDoctorInsurances(user.doctorHeadId)
          break
      }
    }
  }

  // async mounted() {
  //   if (isAuthenticated() && localStorage.getItem('token')) {
  //     const currentUser: CurrentUser = JSON.parse(
  //       localStorage.getItem('currentUser')
  //     )
  //   }
  // }
  async _getDoctorInsurances(rmtuserId: number) {
    await getDoctorInsurances(rmtuserId).then(response => {
      this.$store.dispatch('app/addUserInsurance', response)
    })
  }
  async getUserInsurances(rmtuserId: number) {
    await getUserInsurances(rmtuserId).then(response => {
      this.$store.dispatch('app/addUserInsurance', response)
    })
  }
}
